<template>
  <div class="my-10 px-5 w-100 sm:my-2 sm:px-6 sm:w-full">
    <div class="mb-[72px] text-center login-form__title-block sm:mb-5">
      <h1 class="font-light mb-4 text-black text-4xl">
        登入
      </h1>
      <span class="text-sm text-gray-500">
        登入查看有哪些訂購可以參與
      </span>
    </div>
    <form>
      <w-input
        v-model.lazy="form.identification"
        :disabled="hasIdentificationParam"
        :message="getErrorMsgs('identification')"
        :show-error="hasErrorMsgs('identification')"
        :show-success="!loginValidator$.form.identification.invalid
          && loginValidator$.form.identification.$dirty"
        class="w-full"
        placeholder="統一編號"
        type="number"
        @blur="loginValidator$.form.identification.$touch()"
        @keydown="onNumberInputKeydown"
      />
      <w-input
        v-model.lazy="form.account"
        :message="getErrorMsgs('account')"
        :show-error="hasErrorMsgs('account')"
        :show-success="!loginValidator$.form.account.invalid && loginValidator$.form.account.$dirty"
        class="w-full"
        placeholder="帳號"
        type="text"
        @blur="loginValidator$.form.account.$touch()"
      />
      <w-input
        v-model.lazy="form.password"
        :message="getErrorMsgs('password')"
        :show-error="hasErrorMsgs('password')"
        :show-success="
          !loginValidator$.form.password.invalid && loginValidator$.form.password.$dirty
        "
        class="w-full"
        password-reveal
        placeholder="密碼"
        type="password"
        @blur="loginValidator$.form.password.$touch()"
      />
      <w-button
        :disabled="logging || (loginValidator$.form.$invalid && loginValidator$.form.$dirty)"
        :loading="logging"
        class="w-full"
        @click.prevent="login"
      >
        <div
          v-if="logging"
          class="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white m-auto"
        />
        <span v-else>
          登入
        </span>
      </w-button>
      <w-button
        class="text-sm mt-4 px-0 py-0 text-primary-500 w-full"
        variant="text"
        @click.prevent="toggleForgetPwdModal(true)"
      >
        忘記密碼?
      </w-button>
    </form>
    <forget-password
      :open="forgetPwdDialog"
      @close="toggleForgetPwdModal(false)"
    />
  </div>
</template>

<script>
import LoginForm from './LoginForm';

export default LoginForm;
</script>

<style lang="scss" scoped>
@import 'LoginForm';
</style>
